import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { JsonPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import type { Feature } from 'geojson';

/**
 * Dialog that shows the properties of a single pipeline AOI feature (POI) as formatted JSON.
 * Opened when the user clicks an AOI POI feature on the map.
 */
@Component({
  selector: 'lib-pipeline-aoi-detail-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [JsonPipe, MatButton, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose],
  template: `
    <h2 mat-dialog-title>{{ data.properties?.['name'] ?? 'AOI Point of Interest' }}</h2>
    <mat-dialog-content>
      <pre class="aoi-props">{{ data.properties | json }}</pre>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton mat-dialog-close>Close</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .aoi-props {
      font-size: 12px;
      max-height: 400px;
      overflow: auto;
      white-space: pre-wrap;
      word-break: break-all;
    }
  `],
})
export class PipelineAoiDetailDialogComponent {
  readonly data = inject<Feature>(MAT_DIALOG_DATA);
}
